<template lang="pug">
	.creatives-search-bar(v-if="Publisher.SelectedPublisher && Publisher.SelectedPublisher.id" :class="Layout.creativesFilter ? 'filter-exist' : ''" :style="{height: `${Layout.subHeaderHeight}px`}")
		.search-input-cont
			.search-icon.fa.fa-search
			input.search-input(ref="input" placeholder="Filter creatives..." v-model="filter" @input="filterCreatives")
			.search-remove-icon.fa.fa-remove(v-on:click="removeFilter")
</template>

<script>
	import Screen from './../../mixins/screen'

	import { Publisher } from './../../services/Publisher'
	import { Creative } from './../../services/Creative'
	import { Layout } from './../../services/Layout'

	export default {
		name: 'CreativeFilter',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Layout Workspace Changed",
				"Selected Publisher Changed",
				"Creative Fully Loaded",
				"Creative Filter Changed"
			],
			events: {
				"Creatives Filter Changed": function(reason) {

					if (reason === "from-local-storage") this.filter = Layout.creativesFilter;

				}
			}
		},
		components: {},
		data() {

			this.Publisher = Publisher;
			this.Creative = Creative;

			return {
				showed: true,
				filter: Layout.creativesFilter
			};
		},
		methods: {

			collectData() {



			},

			filterCreatives() {

				Layout.setCreativesFilter(this.filter);

			},

			removeFilter() {

				this.filter = '';

				Layout.setCreativesFilter('');

			}

		}
	}
</script>

<style lang="sass">

	.creatives-search-bar
		height: 46px
		text-align: center
		background-color: #343b41
		border-bottom: 1px solid #23282c
		position: absolute
		left: 0
		top: 0
		overflow: hidden
		z-index: 1
		width: 100%

		.search-input-cont
			position: relative
			display: flex
			flex-wrap: wrap
			align-items: stretch
			margin: 8px

			.search-icon
				width: 30px
				height: 30px
				display: flex
				align-items: center
				justify-content: center
				color: white
				background-color: rgba(255, 255, 255, 0.02)
				border: 1px solid rgba(255, 255, 255, 0.04)
				border-right: none
				border-top-left-radius: 3px
				border-bottom-left-radius: 3px
				transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out

				&::before
					opacity: 0.1
					transition: opacity 0.35s ease-in-out

			.search-input
				border: 1px solid rgba(255, 255, 255, 0.04)
				border-left: none
				border-right: none
				color: rgba(255, 255, 255, 0.17)
				background-color: rgba(255, 255, 255, 0.02)
				transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
				outline: none
				width: 220px

			.search-remove-icon
				width: 30px
				height: 30px
				display: flex
				align-items: center
				justify-content: center
				color: white
				background-color: rgba(255, 255, 255, 0.02)
				border: 1px solid rgba(255, 255, 255, 0.04)
				border-left: none
				border-top-right-radius: 3px
				border-bottom-right-radius: 3px
				transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out

				&::before
					opacity: 0
					transition: opacity 0.35s ease-in-out

		.search-input-cont:focus-within,
		&.filter-exist

			.search-icon
				border-color: rgba(255, 255, 255, 0.18)
				background-color: rgba(255, 255, 255, 0.10)

				&::before
					opacity: 1

			.search-input
				border-color: rgba(255, 255, 255, 0.18)
				background-color: rgba(255, 255, 255, 0.10)
				color: rgba(255, 255, 255, 0.87)

			.search-remove-icon
				border-color: rgba(255, 255, 255, 0.18)
				background-color: rgba(255, 255, 255, 0.10)

		&.filter-exist

			.search-remove-icon

				&::before
					opacity: 1
					cursor: pointer

</style>

